import { useQuery } from "@tanstack/react-query";
import { getVariantStatus } from "../openapi/api-client";

export const useVariantStatus = (projectId: string) => {
  return useQuery({
    queryKey: ["variantStatus", { projectId }],
    queryFn: async () => {
      const result = await getVariantStatus({
        query: { projectId },
      });

      if (result.error) {
        throw new Error(result.error.message);
      }

      return result.data;
    },
    enabled: !!projectId,
  });
};
